import angular from 'angular';

import styles from './styles.less';

/* In Angular, a Component is a special kind of directive that uses a simpler configuration
 * which is suitable for a component-based application structure.
 * https://docs.angularjs.org/guide/component
 */

import template from './template.html'
import controller from './controller'

export default angular.module('app.components.reports', [])
    .component('reports', {
        template: template,
        controller: controller,
        controllerAs: 'ctrl',
        bindings: {
            panel: '<'
            //onUpdate: '&'
        }
    })
    .directive('imageOnLoad', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    element.bind('load', function() {
                        //call the function that was passed
                        scope.$apply(attrs.imageonload);
                    });
                }
            };
        })
    .name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/reports.component/index.js
 **/